import { gql, useMutation } from '@apollo/client';
import { CUSTOMER_ACCOUNT_FIELDS } from '../types/CustomerManagementTypes';
import type { CustomerAccountType } from '../types/CustomerManagementTypes';

export const CREATE_CUSTOMER_ACCOUNT = gql`
    mutation CreateCustomerAccount($channelId: Long!, $roleCode: String!) {
        createCustomerAccount(channelId: $channelId, roleCode: $roleCode) {
            ...CustomerAccountFields
        }
    }
    ${CUSTOMER_ACCOUNT_FIELDS}
`;

export const DELETE_CUSTOMER_ACCOUNT = gql`
    mutation DeleteCustomerAccount($accountId: Long!) {
        deleteCustomerAccount(accountId: $accountId)
    }
`;

export const RESET_CUSTOMER_ACCOUNT_PASSWORD = gql`
    mutation ResetCustomerAccountPassword($accountId: Long!) {
        resetCustomerAccountPassword(accountId: $accountId)
    }
`;

export const SEND_CUSTOMER_ACCOUNT_CREDENTIALS = gql`
    mutation SendCustomerAccountCredentials($accountId: Long!, $contactId: Long!) {
        sendCustomerAccountCredentials(accountId: $accountId, contactId: $contactId)
    }
`;

interface CreateCustomerAccountResponse {
    createCustomerAccount: CustomerAccountType;
}

export const useCreateCustomerAccount = () => {
    return useMutation<CreateCustomerAccountResponse>(CREATE_CUSTOMER_ACCOUNT);
};

export const useDeleteCustomerAccount = () => {
    return useMutation<{ deleteCustomerAccount: boolean }>(DELETE_CUSTOMER_ACCOUNT);
};

export const useResetCustomerAccountPassword = () => {
    return useMutation<{ resetCustomerAccountPassword: boolean }>(RESET_CUSTOMER_ACCOUNT_PASSWORD);
};

export const useSendCustomerAccountCredentials = () => {
    return useMutation<{ sendCustomerAccountCredentials: boolean }>(SEND_CUSTOMER_ACCOUNT_CREDENTIALS);
};
